module.exports = __webpack_public_path__ + "img/Alessandro.76a0c1b.png";